import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Tooltip, useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import SearchIcon from '@mui/icons-material/Search';
import BackspaceIcon from '@mui/icons-material/Backspace';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { DataGrid } from "@mui/x-data-grid";

import Application from "../../application";
import MyPanel from "../../myPanel";
import MyLoading from "../../myLoading";
import MyLabel from "../../myLabel";
import MyInput from "../../myInput";
import MyButton from "../../myButton";

const PaginationGridView = ({nomeItem, title, states ,rows, columns, urlAdd, urlVoltar, onClickPesquisa, children, modalAdd, filtro}) => {

    const theme = useTheme();
    
    const navigate = useNavigate()

    const DialogDelete = () => {
        return (<Dialog
        open={states.openDialog.value}
        onClose={()=>states.openDialog.set(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Apagar ${nomeItem}.`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
              {`Você tem certeza que quer apagar o ${nomeItem} "${states.itemDelete.value?.name}"?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='warning' onClick={()=>states.openDialog.set(false)}>cancelar</Button>
          <Button variant='contained' color='error' onClick={()=>states.deletar.set()} autoFocus>
            apagar
          </Button>
        </DialogActions>
      </Dialog>)
    }


    return (
   
        <Application>
                <MyPanel>
                <MyLoading render={states.submit.value}/>   
                <Stack spacing={1}>
                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                        <MyLabel sx={{ fontSize: "15pt", fontWeight: 600, color: theme.palette.primary.main}} component='h1' text={title}/>
                        {
                            urlVoltar ?
                                <MyButton color='warning' onClick={()=>navigate(urlVoltar)} variant='contained' text='Voltar'/>
                            : 
                                null
                        }
                    </Box>
                    {children}
                    <Box>
                        <Box sx={{display:'flex', justifyContent:'space-between'}}>
                            <Box sx={{display:'flex'}}>
                                <Box>
                                    <MyInput size="small" label='Pesquisar' type='text'value={states.pesquisa.value} onChange={(e)=>states.pesquisa.set(e.target.value)}/>
                                </Box>
    
                                <Box>
                                    <Tooltip title="Pesquisar" placement="bottom" arrow>
                                        <Button onClick={onClickPesquisa}><SearchIcon /></Button>
                                    </Tooltip>                
                                    <Tooltip title="Apagar Filtro" placement="bottom" arrow>
                                        <Button onClick={()=>{states.pesquisa.set('')}}><BackspaceIcon /></Button>
                                    </Tooltip>                
                                </Box>
                            </Box>
                            <Box sx={{flex:1, justifyContent:'flex-end', display:'flex', alignItems:'center'}}>
                                {
                                    filtro ? filtro : null
                                }
                                {
                                    urlAdd ?
                                    <Tooltip title={`Adicionar ${nomeItem}`} placement="left" arrow>
                                        <Button onClick={()=>navigate(urlAdd)}><AddCircleOutlineIcon /></Button>
                                    </Tooltip>
                                    :  modalAdd ?
                                    <Tooltip title={`Adicionar ${nomeItem}`} placement="left" arrow>
                                        <Button onClick={()=>modalAdd(modalAdd)}><AddCircleOutlineIcon /></Button>
                                    </Tooltip>
                                    : null
                                }

                            </Box>
                        </Box>
                        <Box sx={{minHeight: 400, marginTop:1}}>
                            <DataGrid 
                                columnHeaderHeight={40}
                                rowHeight={30}                              
                                paginationMode="server" 
                                rowCount={states.pagination.total}
                                pageSizeOptions={[20]} // Deve ser igual ao page_size do Django (18)
                                paginationModel={{
                                    page: states.pagination.page,
                                    pageSize: 20,
                                }}
                                onPaginationModelChange={(newModel) => {
                                    states.pagination.setPage(newModel.page);
                                    states.submit.set(newModel.page + 1);
                                }}
                                rows={rows || []}
                                columns={columns}
                                sx={{
                                    '.MuiDataGrid-columnHeaders': {
                                    backgroundColor: theme.palette.primary.main,
                                    color: 'white',
                                    },
                                }}
                                
                            />
                        </Box>
                       
                    </Box>
                </Stack>
            </MyPanel>
            <DialogDelete />
        </Application>
   
    )
}

export default PaginationGridView;